import React, { useEffect, useState } from 'react';
import { Container, Box } from '@mui/material';
import { ExpenseManager } from '../components/expenses';
import { Projet } from '../types';
import projetService from '../services/projetService';
import PremiumFeatureGuard from '../components/PremiumFeatureGuard';

/**
 * Page de gestion des dépenses
 */
const ExpensesPage: React.FC = () => {
  const [projects, setProjects] = useState<Projet[]>([]);

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    try {
      const data = await projetService.getAll();
      setProjects(data);
    } catch (error) {
      console.error('Erreur lors du chargement des projets:', error);
    }
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <PremiumFeatureGuard featureName="la gestion de comptabilité">
          <ExpenseManager projects={projects} />
        </PremiumFeatureGuard>
      </Box>
    </Container>
  );
};

export default ExpensesPage;
